import { render, staticRenderFns } from "./existing-trainee.vue?vue&type=template&id=96efa214&scoped=true"
import script from "./existing-trainee.vue?vue&type=script&lang=js"
export * from "./existing-trainee.vue?vue&type=script&lang=js"
import style0 from "./existing-trainee.vue?vue&type=style&index=0&id=96efa214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96efa214",
  null
  
)

export default component.exports